<script>
export default {
  name: "FooterMenu"
}
</script>

<template>
  <footer class="container py-5">
    <div class="row">
      <div class="col-12 col-md">
        <small class="d-block mb-3 text-body-secondary"
        >&copy; Dart Club Wisła</small
        >
      </div>
      <div class="col-6 col-md">
        <h5>Features</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Cool stuff</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Random feature</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Team feature</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Stuff for developers</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Another one</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Last time</a
            >
          </li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>Resources</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Resource name</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Resource</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Another resource</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Final resource</a
            >
          </li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>Resources</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Business</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Education</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Government</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#">Gaming</a>
          </li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>About</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="link-secondary text-decoration-none" href="#">Team</a>
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Locations</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#"
            >Privacy</a
            >
          </li>
          <li>
            <a class="link-secondary text-decoration-none" href="#">Terms</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<style scoped>

</style>